import { synopsisParagraphs } from "@/mocks/manga";

const highlights = [
  { icon: "ri-home-heart-line", text: "同居日常" },
  { icon: "ri-moon-foggy-line", text: "夜晚谈心" },
  { icon: "ri-hearts-line", text: "暗生情愫" },
  { icon: "ri-question-answer-line", text: "误解与和解" },
];

export default function Synopsis() {
  return (
    <section id="synopsis" className="bg-background-50 py-14 md:py-20">
      <div className="mx-auto grid max-w-7xl gap-10 px-4 md:px-6 lg:grid-cols-[1fr_1.2fr] lg:items-center">
        <div className="relative">
          <div className="overflow-hidden rounded-xl">
            <img
              src="https://bainwo.github.io/api/search-image?query=anime%20manga%20illustration%20of%20a%20gyaru%20girl%20and%20a%20boy%20sitting%20close%20on%20a%20warm%20couch%20in%20a%20cozy%20apartment%20at%20dusk%2C%20peach%20and%20cream%20palette%2C%20soft%20window%20light%2C%20youth%20romance%20manga%20art%20style%2C%20gentle%20intimate%20mood%2C%20high%20detail&width=900&height=660&seq=synopsis-img-01&orientation=landscape"
              alt="泡在我家的辣妹 同居日常插画"
              className="h-full w-full object-cover"
            />
          </div>
          <div className="absolute -bottom-4 right-4 flex items-center gap-2 rounded-lg bg-accent-500 px-4 py-2 text-background-50">
            <i className="ri-fire-fill text-lg" />
            <span className="font-heading text-sm">借宿同居 · 青春恋爱日常</span>
          </div>
        </div>

        <div>
          <span className="inline-flex items-center gap-1.5 rounded-full bg-accent-100 px-3 py-1 text-xs font-medium text-accent-800">
            <i className="ri-book-2-line text-sm" />
            故事简介
          </span>
          <h2 className="font-heading mt-3 text-3xl text-foreground-950 md:text-4xl">
            一个屋檐下的心动日常
          </h2>
          {synopsisParagraphs.map((p) => (
            <p key={p.slice(0, 8)} className="mt-4 text-[15px] leading-7 text-foreground-700">
              {p}
            </p>
          ))}
          <div className="mt-6 flex flex-wrap gap-2">
            {highlights.map((h) => (
              <span
                key={h.text}
                className="inline-flex items-center gap-1.5 rounded-md bg-secondary-100 px-3 py-1.5 text-xs font-medium text-secondary-900"
              >
                <i className={`${h.icon} text-primary-600`} />
                {h.text}
              </span>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}